import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { HeaderWithFilterProps } from "@/components/data-table/types/header-with-filter-props.type";

export const MultipleFilter = ({ item, selected, onChangePage }: Omit<HeaderWithFilterProps, "label">) => {
  const selectedValues = selected || [];

  const onSelect = (value: string, checked: boolean) => {
    let newSelected = [...selectedValues]; // Create a new array instead of mutating
    if (checked) {
      newSelected.push(value);
    } else {
      newSelected = selectedValues.filter((item) => item !== value);
    }
    onChangePage(newSelected);
  };

  return item.options?.map((item) => {
    const isSelected = selectedValues.includes(item.value);
    return (
      <div className="flex items-center gap-3" key={item.value}>
        <Checkbox
          id={`payment-${item.value}`}
          checked={isSelected}
          className="data-[state=checked]:bg-[#1E5F6F] data-[state=checked]:border-[#1E5F6F] border-[#25292D]"
          onCheckedChange={(checked) => {
            onSelect(item.value, checked === true);
          }}
        />
        <Label htmlFor={`payment-${item.value}`} className="cursor-pointer font-extrabold text-xs">
          {item.label}
        </Label>
      </div>
    );
  });
};
